{
	"optionsCreateOrder": {
		"buy": "Buy",
		"sell": "Sell",
		"orderType": "Order Type",
		"price": "Price",
		"bid": "Bid",
		"ask": "Ask",
		"qty": "Quantity",
		"available": "available",
		"orderTerm": "Duration",
		"amount": "Amount",
		"availableFunds": "Available Funds",
		"accepted": "Order for {{ symbol }} was successfully placed",
		"tradingNotAllowed": "Options trading is not permitted.",
		"why": "Why?",
		"whyUnavailable": "Why are options not available?",
		"possibleReasons": "One of the possible reasons:",
		"noBrokerAccount": "You haven't opened a brokerage account",
		"kycIncomplete": "You haven't completed the identity verification process",
		"documentsNotSigned": "You haven't signed the required documents",
		"moderationPending": "You haven't passed moderation",
		"optionsNotEnabled": "You haven't enabled options trading",
		"personalDataUpdating": "Personal data updates after changes",
		"contactSupport": "Contact with support:",
		"whatsapp": "WhatsApp",
		"email": "E-mail",
		"errors": {
			"notAllowed": "Options trading is not permitted"
		},
		"warnings": {
			"closeNotAvailable": "Closing a position with a Market order is currently unavailable"
		}
	}
}
